egtoDomain.$inject = [];

export function egtoDomain() {
    return {
        require: '^form',
        bindToController: {
            label: '@',
            organization: '=',
            email: '=',
            name: '@',
            userType: '=',
            show: '@'
        },
        restrict: 'E',
        scope: {},
        controller: EgtoDomainController,
        controllerAs: 'vm',
        templateUrl: 'app/components/egto-domain.directive.html',
        link: link
    };

    function link(scope, element, attributes, form) {
        var domains;

        scope.vm.field = form[scope.vm.name];

        if (scope.vm.organization) {
            domains = scope.vm.organization.securityConfiguration.validEmailDomains;
            scope.vm.field.$validators.egtoDomainValidation = egtoDomainValidation;
        }

        ///////////////////

        function egtoDomainValidation(modelValue, viewValue) {
            if (!viewValue || domains.length === 0) {
                return true;
            }
            if(scope.vm.userType === 'EXTRANET') {
                return true;
            }
            return domains.some(domain => domainEndsWith(viewValue, domain));
        }

        function domainEndsWith(str, suffix) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }
    }
}
class EgtoDomainController {
    constructor() {
    }
}
EgtoDomainController.$inject = [];